import type { TrackingMilestone } from '../../api/endpoints/admin';
import { shipmentStatusLabel } from './shipmentStatusLabel';

export interface MilestoneOption {
  value: TrackingMilestone;
  label: string;
}

function option(value: TrackingMilestone): MilestoneOption {
  return { value, label: shipmentStatusLabel(value) };
}

export function getAvailableMilestones(status?: string): MilestoneOption[] {
  switch (status) {
    case 'ASSIGNED':
      return [
        option('EN_ROUTE_PICKUP'),
        option('AT_PICKUP'),
      ];
    case 'EN_ROUTE_PICKUP':
      return [option('AT_PICKUP')];
    case 'LOADED':
      return [option('IN_TRANSIT')];
    case 'IN_TRANSIT':
      return [
        option('AT_DROP'),
        option('DELIVERED'),
      ];
    case 'AT_DROP':
      return [option('DELIVERED')];
    default:
      return [];
  }
}
